const CREDENTIALS_KEY = 'userCredentials';

/**
 * Strips the plaintext `password` that older builds persisted into the `userCredentials`
 * entry alongside the "Remember me" identifier. Those writes are gone, but the secret is
 * still sitting on the disk of every player who ever ticked the box, and it survives
 * logout and token rotation — so it has to be cleared on their next visit.
 *
 * The identifier fields are kept so "Remember me" keeps working. Runs before render.
 */
export const purgeStoredPassword = (): void => {
  // Runs before render, outside any ErrorBoundary, so nothing here may throw: browsers with site
  // data blocked raise SecurityError on any localStorage access, which would white-screen the app.
  try {
    if (typeof localStorage === 'undefined') return;

    const stored = localStorage.getItem(CREDENTIALS_KEY);
    if (!stored) return;

    let credentials;
    try {
      credentials = JSON.parse(stored);
    } catch {
      // Unparseable entry: drop it rather than leave an unknown payload behind.
      localStorage.removeItem(CREDENTIALS_KEY);
      return;
    }

    if (!credentials || typeof credentials !== 'object' || !('password' in credentials)) return;

    delete credentials.password;
    localStorage.setItem(CREDENTIALS_KEY, JSON.stringify(credentials));
  } catch {
    // Storage unavailable (SecurityError / quota). Nothing to purge and nothing we can do.
  }
};
